import { APP_INITIALIZER, NgModule } from '@angular/core'
import { CampusModalComponent } from './campus-modal.component'
import { MbCampusModalService } from '../../../services/mb-campus-modal/campus-modal.service'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { MbI18nModule } from '../../../../translations/mb-i18n.module'
import { CmsService } from '@spartacus/core'
import { MbCaasService } from '../../../services/mb-caas/mb-caas.service'
import { CmsDOMInputParser } from '../../../../shared/utils/cms-dom-input-parser'
import { CookieService } from 'ngx-cookie-service'
import { Router } from '@angular/router'
import { LinkModule } from '../link/link.module'

@NgModule({
  declarations: [
    CampusModalComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    MbI18nModule,
    LinkModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (mbCampusModalService: MbCampusModalService) => () => mbCampusModalService,
      deps: [MbCampusModalService, CmsService, MbCaasService, CmsDOMInputParser, CookieService, Router],
      multi: true
    },
  ],
  exports: [
    CampusModalComponent
  ]
})
export class CampusModalModule {
}

